if(jQuery('.accordion').length) {
  
  jQuery('.accordion-title').click(function() {
    
    jQuery('.accordion-title').attr('data-after','+');
  	  
    var content = jQuery(this).next('.accordion-content');
    
    if(content.css('display') == 'block') {
      jQuery('.accordion-content').css('display', 'none');
      content.css('display', 'none');
    } else {
      jQuery(this).attr('data-after','-');
      jQuery('.accordion-content').css('display', 'none');
      content.css('display','block');
    }
    
  });
  
}

jQuery(document).ready(function() {
  console.log('ready');
  jQuery('.shappify_option_name').click(function() {
    //console.log('hii');
    //jQuery(this).siblings ('.shappify_tool_tip').css('display','block');
  }); 
  
});